// Generated file : do not modify
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import ListData from '@/extend/classes/ListData';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Encours autorisé
export class AuthorizedCreditPayroll {
  // Identifiant de la paie
  public paieId: number;
  // Numéro de paie
  public codeCheque: number;
  // Salarié
  public employee: string;
  // Période
  public period: string;
  // Montant à financer
  public amount: number;
  // Encours nécessaire
  public requiredCreditLimit: number;
  // Motif
  public reason: string;

  constructor() {
    this.paieId = 0;
    this.codeCheque = 0;
    this.employee = '';
    this.period = '';
    this.amount = 0;
    this.requiredCreditLimit = 0;
    this.reason = '';
  }
}

export default class AuthorizedCredit  {
  // Identifiant
  public id: number;
  // Code établissement
  public etablissementId: number;
  // Établissement
  public etablissement: string;
  // Encours autorisé
  public creditLimit: number;
  // Encours consommé
  public consumedCredit: number;
  // Permanent
  public permanent: boolean;
  // Autorisé jusqu'au
  public creditLimitUntil: Date | null;
  // Autorisation active
  public authorized: boolean;
  // Proposition de déblocage
  public proposed: boolean;
  // Déblocage en cours
  public inProgress: boolean;
  // Encours proposé
  public proposedCreditLimit: number;
  // Motif de la proposition
  public proposalReason: string;
  // Paies concernées
  public proposalPayrolls: string;
  // Nombre de paies concernées
  public proposalPayrollCount: number;
  // Paie à débloquer
  public proposalPayrollId: number;
  // Détail des paies concernées
  public proposalPayrollDetails: AuthorizedCreditPayroll[];
  // Commande non exécutée
  public failed: boolean;

  constructor() {
    this.id = 0;
    this.etablissementId = 0;
    this.etablissement = '';
    this.creditLimit = 0;
    this.consumedCredit = 0;
    this.permanent = false;
    this.creditLimitUntil = null;
    this.authorized = false;
    this.proposed = false;
    this.inProgress = false;
    this.proposedCreditLimit = 0;
    this.proposalReason = '';
    this.proposalPayrolls = '';
    this.proposalPayrollCount = 0;
    this.proposalPayrollId = 0;
    this.proposalPayrollDetails = [];
    this.failed = false;
  }

  public static fromJson (obj: AuthorizedCredit): AuthorizedCredit {
    const newAuthorizedCredit: AuthorizedCredit = new AuthorizedCredit();
    newAuthorizedCredit.id = obj.id;
    newAuthorizedCredit.etablissementId = obj.etablissementId;
    newAuthorizedCredit.etablissement = obj.etablissement;
    newAuthorizedCredit.creditLimit = obj.creditLimit;
    newAuthorizedCredit.consumedCredit = obj.consumedCredit;
    newAuthorizedCredit.permanent = obj.permanent;
    newAuthorizedCredit.creditLimitUntil = obj.creditLimitUntil ? new Date(obj.creditLimitUntil) : null;
    newAuthorizedCredit.authorized = obj.authorized;
    newAuthorizedCredit.proposed = obj.proposed;
    newAuthorizedCredit.inProgress = obj.inProgress;
    newAuthorizedCredit.proposedCreditLimit = obj.proposedCreditLimit;
    newAuthorizedCredit.proposalReason = obj.proposalReason;
    newAuthorizedCredit.proposalPayrolls = obj.proposalPayrolls;
    newAuthorizedCredit.proposalPayrollCount = obj.proposalPayrollCount;
    newAuthorizedCredit.proposalPayrollId = obj.proposalPayrollId;
    newAuthorizedCredit.proposalPayrollDetails = JSON.parse(JSON.stringify(obj.proposalPayrollDetails));
    newAuthorizedCredit.failed = obj.failed;
    return newAuthorizedCredit;
  }

  public toJsonAuthorizedCredit (): string {
    const json = {
      id: this.id,
      etablissementId: this.etablissementId,
      etablissement: this.etablissement,
      creditLimit: this.creditLimit,
      consumedCredit: this.consumedCredit,
      permanent: this.permanent,
      creditLimitUntil: this.creditLimitUntil ? new Date (this.creditLimitUntil).toString() : this.creditLimitUntil,
      authorized: this.authorized,
      proposed: this.proposed,
      inProgress: this.inProgress,
      proposedCreditLimit: this.proposedCreditLimit,
      proposalReason: this.proposalReason,
      proposalPayrolls: this.proposalPayrolls,
      proposalPayrollCount: this.proposalPayrollCount,
      proposalPayrollId: this.proposalPayrollId,
      proposalPayrollDetails: this.proposalPayrollDetails,
    }
    return JSON.stringify(json);
  }

  public fromAuthorizedCredit (obj: AuthorizedCredit): void {
    this.id = obj.id;
    this.etablissementId = obj.etablissementId;
    this.etablissement = obj.etablissement;
    this.creditLimit = obj.creditLimit;
    this.consumedCredit = obj.consumedCredit;
    this.permanent = obj.permanent;
    this.creditLimitUntil = obj.creditLimitUntil;
    this.authorized = obj.authorized;
    this.proposed = obj.proposed;
    this.inProgress = obj.inProgress;
    this.proposedCreditLimit = obj.proposedCreditLimit;
    this.proposalReason = obj.proposalReason;
    this.proposalPayrolls = obj.proposalPayrolls;
    this.proposalPayrollCount = obj.proposalPayrollCount;
    this.proposalPayrollId = obj.proposalPayrollId;
    this.proposalPayrollDetails = obj.proposalPayrollDetails;
    this.failed = obj.failed;
  }

  public compareAuthorizedCredit (value: AuthorizedCredit): boolean {
    return (this.toJsonAuthorizedCredit() == value.toJsonAuthorizedCredit());
  }

  public cloneAuthorizedCredit (): AuthorizedCredit {
    return AuthorizedCredit.fromJson(this);
  }

  public static list (): Promise<AuthorizedCredit[]> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/authorizedcredits/list', getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const cData: AuthorizedCredit[] = [];
              res.data.forEach(( a: AuthorizedCredit ) => {
                cData.push(AuthorizedCredit.fromJson(a));
              })
              resolve(cData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static save (authorizedCredit: AuthorizedCredit): Promise<AuthorizedCredit> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/authorizedcredits/save', authorizedCredit, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(AuthorizedCredit.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static reset (authorizedCredit: AuthorizedCredit): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/authorizedcredits/reset', authorizedCredit, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static unlock (authorizedCredit: AuthorizedCredit): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/authorizedcredits/unlock', authorizedCredit, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getDate(authorizedCredits: AuthorizedCredit[]) {
    authorizedCredits.forEach((item) => {
      item.creditLimitUntil = item.creditLimitUntil ? new Date(item.creditLimitUntil) : item.creditLimitUntil;
    })
  }
}
